<template>
  <div class="handleAgency">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="740px"
      :before-close="handleClose"
    >
      <div class="form_box">
        <el-form
          ref="formInline"
          :model="formInline"
          :rules="rules"
          label-width="190px"
        >
          <div class="title">1、单位基本信息</div>
          <el-form-item label="联系人姓名" prop="contactsName">
            <el-input
              v-model="formInline.contactsName"
              :disabled="operationBool"
              placeholder="请填写您的姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系人手机号" prop="contactsPhone">
            <el-input
              v-model="formInline.contactsPhone"
              :disabled="operationBool"
              placeholder="请填写您的手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="单位名称" prop="name">
            <el-input
              v-model="formInline.name"
              :disabled="operationBool"
              placeholder="请填写单位名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系人职务" prop="contactsPosition">
            <el-input
              v-model="formInline.contactsPosition"
              :disabled="operationBool"
              placeholder="请填写您的职务"
            ></el-input>
          </el-form-item>
          <el-form-item label="单位网址" prop="unitWebsite">
            <el-input
              v-model="formInline.unitWebsite"
              :disabled="operationBool"
              placeholder="请填写单位网址"
            ></el-input>
          </el-form-item>
          <el-form-item label="法定代表人姓名" prop="legalRepresentative">
            <el-input
              v-model="formInline.legalRepresentative"
              :disabled="operationBool"
              placeholder="请填写法定代表人姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="成立时间" prop="setUpTime">
            <el-date-picker
              v-model="formInline.setUpTime"
              :disabled="operationBool"
              type="date"
              :editable="false"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="员工总人数" prop="staffSum">
            <el-input
              v-model="formInline.staffSum"
              maxlength="10"
              :disabled="operationBool"
              @input="formInline.staffSum = Number(formInline.staffSum) || ''"
              placeholder="请填写员工总人数"
            ></el-input>
          </el-form-item>
          <el-form-item label="营业执照号" prop="licenseNum">
            <el-input
              v-model="formInline.licenseNum"
              :disabled="operationBool"
              placeholder="请填写营业执照号"
            ></el-input>
          </el-form-item>
          <el-form-item label="注册资金（万元）" prop="registeredCapital">
            <el-input
              v-model="formInline.registeredCapital"
              maxlength="10"
              :disabled="operationBool"
              @input="
                formInline.registeredCapital =
                  Number(formInline.registeredCapital) || ''
              "
              placeholder="请填写注册资金（万元）"
            ></el-input>
          </el-form-item>
          <el-form-item label="实缴资金（万元）" prop="paidInCapital">
            <el-input
              v-model="formInline.paidInCapital"
              maxlength="10"
              :disabled="operationBool"
              @input="
                formInline.paidInCapital =
                  Number(formInline.paidInCapital) || ''
              "
              placeholder="请填写实缴资金（万元）"
            ></el-input>
          </el-form-item>
          <el-form-item label="社会培训评价组织" prop="filingSituation">
            备案情况：
            <el-radio-group
              v-model="formInline.filingSituation"
              :disabled="operationBool"
              @change="filingSituationChange"
            >
              <el-radio :label="1">未在人社局备案</el-radio>
              <el-radio :label="2">已在人社局备案</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="（人社部第三方）" prop="evaluableOccupation">
            可评价职业（工种）
            <el-input
              :disabled="formInline.filingSituation === 1 || operationBool"
              v-model="formInline.evaluableOccupation"
              placeholder="请输入"
              maxlength="50"
            ></el-input>
          </el-form-item>
          <el-form-item label="营业执照" prop="licenseUrl">
            <Upload v-if="!operationBool" v-model="formInline.licenseUrl">
              <img
                class="apply-img"
                slot="img"
                v-if="formInline.licenseUrl"
                :src="formInline.licenseUrl"
                alt="营业执照"
              />
            </Upload>
            <template v-else>
              <el-image
                v-if="formInline.licenseUrl"
                style="width: 360px; height: 180px"
                :src="formInline.licenseUrl"
                :preview-src-list="[formInline.licenseUrl]"
              >
              </el-image>
              <span v-else>--</span>
            </template>
          </el-form-item>
          <el-form-item
            label="法人身份证正面"
            prop="legalRepresentativeIdFront"
          >
            <Upload
              v-if="!operationBool"
              v-model="formInline.legalRepresentativeIdFront"
            >
              <img
                class="apply-img"
                slot="img"
                v-if="formInline.legalRepresentativeIdFront"
                :src="formInline.legalRepresentativeIdFront"
                alt="法人身份证正面"
              />
            </Upload>
            <template v-else>
              <el-image
                v-if="formInline.legalRepresentativeIdFront"
                style="width: 360px; height: 180px"
                :src="formInline.legalRepresentativeIdFront"
                :preview-src-list="[formInline.legalRepresentativeIdFront]"
              >
              </el-image>
              <span v-else>--</span>
            </template>
          </el-form-item>
          <el-form-item
            label="法人身份证反面"
            prop="legalRepresentativeIdReverse"
          >
            <Upload
              v-if="!operationBool"
              v-model="formInline.legalRepresentativeIdReverse"
            >
              <img
                class="apply-img"
                slot="img"
                v-if="formInline.legalRepresentativeIdReverse"
                :src="formInline.legalRepresentativeIdReverse"
                alt="法人身份证反面"
              />
            </Upload>
            <template v-else>
              <el-image
                v-if="formInline.legalRepresentativeIdReverse"
                style="width: 360px; height: 180px"
                :src="formInline.legalRepresentativeIdReverse"
                :preview-src-list="[formInline.legalRepresentativeIdReverse]"
              >
              </el-image>
              <span v-else>--</span>
            </template>
          </el-form-item>
          <div class="title">2、主营业务信息</div>
          <el-form-item
            label="培训业务经验（年）"
            prop="trainingBusinessExperience"
          >
            <el-input
              v-model="formInline.trainingBusinessExperience"
              :disabled="operationBool"
              placeholder="请填写培训业务经验"
            ></el-input>
          </el-form-item>
          <el-form-item label="培训模式（面授/远程/综合）" prop="trainingMode">
            <el-input
              v-model="formInline.trainingMode"
              :disabled="operationBool"
              placeholder="请填写培训模式"
            ></el-input>
          </el-form-item>
          <el-form-item label="培训主题方向" prop="trainingTopics">
            <el-input
              v-model="formInline.trainingTopics"
              :disabled="operationBool"
              placeholder="请填写培训主题方向"
            ></el-input>
          </el-form-item>
          <el-form-item label="累计培训人次" prop="trainingPersonTimes">
            <el-input
              v-model="formInline.trainingPersonTimes"
              maxlength="10"
              :disabled="operationBool"
              placeholder="请填写累计培训人次"
            ></el-input>
          </el-form-item>
          <el-form-item label="自有授课场地面积" prop="siteArea">
            <el-input
              v-model="formInline.siteArea"
              maxlength="10"
              :disabled="operationBool"
              placeholder="请填写自有授课场地面积"
            ></el-input>
          </el-form-item>
          <el-form-item label="自有实操场所/设施" prop="operationPlace">
            <el-input
              v-model="formInline.operationPlace"
              :disabled="operationBool"
              placeholder="请填写自有实操场所/设施"
            ></el-input>
          </el-form-item>
          <el-form-item label="最优招生省域或渠道" prop="studentsChannel">
            <el-input
              v-model="formInline.studentsChannel"
              :disabled="operationBool"
              placeholder="请填写最优招生省域或渠道"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="培训相关经验介绍"
            prop="trainingExperienceIntroduce"
          >
            <el-input
              type="textarea"
              :disabled="operationBool"
              :rows="5"
              maxlength="2000"
              show-word-limit
              v-model="formInline.trainingExperienceIntroduce"
              placeholder="请填写你方之前展开相关培训的具体情况（包括但不限于培训主题、参训人数、已孵化网红人数、配套产品等等）"
            ></el-input>
          </el-form-item>
          <el-form-item label="招生资源简要介绍" prop="studentsIntroduce">
            <el-input
              type="textarea"
              :disabled="operationBool"
              :rows="5"
              maxlength="2000"
              show-word-limit
              v-model="formInline.studentsIntroduce"
              placeholder="请详细介绍你方培训招生来源、渠道等情况"
            ></el-input>
          </el-form-item>
          <el-form-item label="其他主营业务" prop="otherBusiness">
            <el-input
              type="textarea"
              :disabled="operationBool"
              :rows="5"
              maxlength="2000"
              show-word-limit
              v-model="formInline.otherBusiness"
              placeholder="请填写培训以外其他主营业务情况"
            ></el-input>
          </el-form-item>
          <div class="title">3、合作意向</div>
          <el-form-item label="合作意愿" prop="cooperateDesire">
            <el-checkbox-group
              v-model="formInline.cooperateDesire"
              :disabled="operationBool"
              @change="cooperateDesireChange"
            >
              <el-checkbox
                v-for="item in intendList"
                :key="item.value"
                :label="item.value"
              >
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label=" " prop="otherDesire">
            <el-input
              :disabled="
                !(
                  formInline.cooperateDesire &&
                  formInline.cooperateDesire.includes('3')
                ) || operationBool
              "
              placeholder="请输入"
              v-model="formInline.otherDesire"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remarks">
            <el-input
              type="textarea"
              maxlength="500"
              :rows="3"
              style="width: 400px"
              :disabled="status === 'distribution_audit'"
              v-model="formInline.remarks"
              placeholder="请输入备注"
            ></el-input>
            <el-button
              v-if="operationBool && checkAdmin()"
              style="margin-left: 8px"
              size="small"
              :disabled="status === 'distribution_audit'"
              type="primary"
              @click="keepRemarks"
              >保存</el-button
            >
          </el-form-item>
          <div class="title">4、系统信息</div>
          <el-form-item label="企业logo" prop="logo">
            <Upload v-if="!(proxyAuditState && proxyAuditState > 0) || status !== 'distribution_audit'" v-model="formInline.logo">
              <img
                class="apply-img"
                slot="img"
                v-if="formInline.logo"
                :src="formInline.logo"
                alt="企业logo"
              />
            </Upload>
            <template v-else>
              <el-image
                v-if="formInline.logo"
                style="width: 360px; height: 180px"
                :src="formInline.logo"
                :preview-src-list="[formInline.logo]"
              >
              </el-image>
              <span v-else>--</span>
            </template>
          </el-form-item>
          <div class="title">5、合作信息</div>
          <el-form-item label="保证金截图" prop="marginPic">
            <Upload v-model="formInline.marginPic" v-if="status !== 'distribution_audit'">
              <img
                class="apply-img"
                slot="img"
                v-if="formInline.marginPic"
                :src="formInline.marginPic"
                alt="保证金截图"
              />
            </Upload>
            <template v-else>
              <el-image
                v-if="formInline.marginPic"
                style="width: 100px; height: 100px"
                :src="formInline.marginPic"
                :preview-src-list="[formInline.marginPic]"
              >
              </el-image>
              <span v-else>--</span>
            </template>
          </el-form-item>
          <el-form-item label="合同名称" prop="contractName" v-if="(status !== 'agency_alter' && status !== 'distribution_alter') || statusPage === 'audit'">
            <el-input
              v-model="formInline.contractName"
              maxlength="50"
              :disabled="status === 'distribution_audit'"
              placeholder="请输入合同名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="合同生效日期" prop="contractValidityStart" v-if="(status !== 'agency_alter' && status !== 'distribution_alter') || statusPage === 'audit'">
            <el-date-picker
              v-model="formInline.contractValidityStart"
              type="date"
              :disabled="status === 'distribution_audit'"
              :editable="false"
              placeholder="开始时间"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="合同截止日期" prop="contractValidityEnd" v-if="(status !== 'agency_alter' && status !== 'distribution_alter') || statusPage === 'audit'">
            <el-date-picker
              v-model="formInline.contractValidityEnd"
              type="date"
              :editable="false"
              :disabled="status === 'distribution_audit'"
              placeholder="截止时间"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="合同附件" prop="contractUrl" v-if="(status !== 'agency_alter' && status !== 'distribution_alter') || statusPage === 'audit'">
            <el-upload
              ref="upload"
              :limit="1"
              :format="['pdf']"
              accept=".pdf, .PDF"
              :action="uploadHost"
              :data="uploadData"
              :before-upload="beforeUpload"
              :on-success="handleSuccess"
              :on-remove="handleRemove"
              :clearFiles="clearFiles"
              :file-list="file_list"
              :on-format-error="handleFormatError"
              v-if="status !== 'distribution_audit'"
            >
              <el-button slot="trigger" size="small" type="primary"
                >上传文件</el-button
              >
              <div slot="tip" class="el-upload__tip">支持.PDF格式文件</div>
            </el-upload>
            <!-- <el-button size="small" type="primary" disabled
              >上传文件</el-button
            > -->
            <span
              class="blue_Box"
              v-if="formInline.contractUrl"
              @click="lookFile(formInline.contractUrl)"
              >预览</span
            >
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">关 闭</el-button>
        <el-button
          v-if="status === 'agency_add' || status === 'agency_alter'"
          size="small"
          type="primary"
          @click="handleAffirm"
          >保 存</el-button
        >
        <el-button
          v-if="
            status === 'distribution_add' || status === 'distribution_alter'
          "
          size="small"
          type="primary"
          @click="handleAffirm"
          >提交审核</el-button
        >
        <template
          v-else-if="
            status === 'distribution_details' &&
            proxyAuditState === '' &&
            !checkAdmin()
          "
        >
          <el-button
            size="small"
            type="danger"
            @click="handleCooperation('2', formInline)"
            >不合作</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="handleCooperation('1', formInline)"
            >确定合作</el-button
          >
        </template>
        <template
          v-else-if="status === 'distribution_audit' && auditState === ''"
        >
          <el-button
            size="small"
            type="danger"
            @click="handleAudit('2', formInline)"
            >审核驳回</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="handleAudit('1', formInline)"
            >审核通过</el-button
          >
        </template>
      </span>
    </el-dialog>

    <!-- 拒绝原因 -->
    <AddRejectReason ref="addRejectReasonRef" @refresh="refresh" />
  </div>
</template>

<script>
// 引入生成上传参数方法
import { oss } from "@/libs/uploadFile";
import { getpublicImgUrl } from "@/api/base/api-upload";
import {
  // proxyAuditApply,
  addCooperationApply,
  updateCompanyInfo,
  getCompanyInfo,
  getCooperationApply,
  auditCooperationApply,
  updateCooperationApply,
} from "@/api/organization";
import Upload from "@/components/upload.vue";
import AddRejectReason from "@/views/organization/components/addRejectReason.vue";
import { clone } from "@/utils/handle.js";
export default {
  components: { Upload, AddRejectReason },
  props: {
    // 判断页面来源是否是招生服务方审核
    statusPage: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogTitle: "",
      dialogVisible: false,
      intendList: [
        {
          label: "全媒体运营师培训+考核",
          value: "6",
        },
        {
          label: "网络主播培训+考核",
          value: "7",
        },
        {
          label: "其他",
          value: "8",
        },
      ],
      formInline: {
        contactsName: "",
        contactsPhone: "",
        name: "",
        contactsPosition: "",
        unitWebsite: "",
        legalRepresentative: "",
        setUpTime: "",
        staffSum: "",
        licenseNum: "",
        registeredCapital: "",
        paidInCapital: "",
        filingSituation: 1,
        evaluableOccupation: "",
        otherDesire: "",
        licenseUrl: "",
        legalRepresentativeIdFront: "",
        legalRepresentativeIdReverse: "",
        trainingBusinessExperience: "",
        trainingMode: "",
        trainingTopics: "",
        trainingPersonTimes: "",
        siteArea: "",
        operationPlace: "",
        studentsChannel: "",
        trainingExperienceIntroduce: "",
        studentsIntroduce: "",
        otherBusiness: "",
        cooperateDesire: [],
        remarks: "",
        marginPic: "",
        contractName: "",
        contractValidityStart: "",
        contractValidityEnd: "",
        contractUrl: "",
      },
      rules: {
        contactsName: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" },
        ],
        contactsPhone: [
          { required: true, message: "请输入联系人手机号", trigger: "blur" },
        ],
        contactsPosition: [
          { required: true, message: "请输入联系人职务", trigger: "blur" },
        ],
        unitWebsite: [
          { required: true, message: "请输入单位网址", trigger: "blur" },
        ],
        legalRepresentative: [
          { required: true, message: "请输入法定代表人姓名", trigger: "blur" },
        ],
        setUpTime: [
          { required: true, message: "请选择成立时间", trigger: "blur" },
        ],
        staffSum: [
          { required: true, message: "请输入员工总人数", trigger: "blur" },
        ],
        licenseNum: [
          { required: true, message: "请输入营业执照号", trigger: "blur" },
        ],
        trainingPersonTimes: [
          { pattern: /^\d{1,}$/, message: "请输入正整数", trigger: "blur" },
        ],
        registeredCapital: [
          { required: true, message: "请输入注册资金", trigger: "blur" },
        ],
        licenseUrl: [{ required: true, message: "请上传营业执照" }],
        legalRepresentativeIdFront: [
          { required: true, message: "请上传法人身份证正面" },
        ],
        legalRepresentativeIdReverse: [
          { required: true, message: "请上传法人身份证反面" },
        ],
        studentsChannel: [
          {
            required: true,
            message: "请输入最优招生省城或渠道",
            trigger: "blur",
          },
        ],
        trainingExperienceIntroduce: [
          {
            required: true,
            message: "请输入培训相关经验或介绍",
            trigger: "blur",
          },
        ],
        studentsIntroduce: [
          {
            required: true,
            message: "请输入招生资源简要介绍",
            trigger: "blur",
          },
        ],
        name: [{ required: true, message: "请填写单位名称", trigger: "blur" }],
        cooperateDesire: [
          { required: true, message: "必填项不可为空", trigger: "blur" },
        ],
        evaluableOccupation: [
          {
            required: false,
            message: "必填项不可为空",
            trigger: "blur",
          },
        ],
        otherDesire: [
          { required: false, message: "必填项不可为空", trigger: "blur" },
        ],
        filingSituation: [
          { required: true, message: "必填项不可为空", trigger: "blur" },
        ],
        contractName: [
          { required: true, message: "请输入合同名称", trigger: "blur" },
        ],
        contractValidityStart: [
          { required: true, message: "请选择合同生效日期", trigger: "change" },
        ],
        contractValidityEnd: [
          { required: true, message: "请选择合同截止日期", trigger: "change" },
        ],
        contractUrl: [{ required: true, message: "请上传合同附件" }],
        marginPic: [{ required: true, message: "请上传保证金截图" }],
        logo: [{ required: true, message: "请上传logo" }],
      },
      operationBool: true,
      status: "",
      // 附件上传路径
      uploadHost: "",
      type: 0,
      path: "public/product/",
      // 附件上传携带参数
      uploadData: {},
      fileData: {
        // 上传后返回的存储的文件名
        fileName: "",
        oFileName: "",
        fileUrl: "",
        uploadRes: null,
      },
      file_list: [],
      auditState: "",
      proxyAuditState: "",
    };
  },
  watch: {
    "formInline.licenseUrl": {
      handler(to) {
        if (to) {
          this.$nextTick(() => {
            this.$refs.formInline.clearValidate("licenseUrl");
          });
        }
      },
      deep: true,
    },
    "formInline.legalRepresentativeIdFront": {
      handler(to) {
        if (to) {
          this.$nextTick(() => {
            this.$refs.formInline.clearValidate("legalRepresentativeIdFront");
          });
        }
      },
      deep: true,
    },
    "formInline.legalRepresentativeIdReverse": {
      handler(to) {
        if (to) {
          this.$nextTick(() => {
            this.$refs.formInline.clearValidate("legalRepresentativeIdReverse");
          });
        }
      },
      deep: true,
    },
    "formInline.contractUrl": {
      handler(to) {
        if (to) {
          this.$nextTick(() => {
            this.$refs.formInline.clearValidate("contractUrl");
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    // 保存备注
    keepRemarks() {
      let params = {
        id: this.formInline.id,
        remarks: this.formInline.remarks,
      };
      updateCooperationApply({ ...params }).then((res) => {
        if (res.code === 0) {
          this.$parent.refresh();
          this.$message({
            message: "编辑成功",
            type: "success",
          });
          this.handleClose()
        }
      });
    },
    // 查看附件
    lookFile(payload) {
      window.open(payload);
    },
    updateCooperationApply(auditStatus, { id, licenseNum }) {
      let message = auditStatus === "1" ? "合作" : "拒绝";
      let messageTitle =
        auditStatus === "1"
          ? "确认要与该教务服务方合作吗?"
          : "确认要拒绝与该教务服务方合作吗?";
      this.$confirm(`${messageTitle}`, "提示", {
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // proxyAuditApply({ auditStatus, id }).then((res) => {
          //   if (res.code === 0) {
          //     this.$parent.refresh();
          //     this.$message({
          //       type: "success",
          //       message: `${message}成功`,
          //     });
          //     this.dialogVisible = false;
          //   }
          // });
          let params = clone(this.formInline);
          params.cooperateDesire = params.cooperateDesire.join(",");
          updateCooperationApply({ ...params, proxyAuditState: auditStatus, id }).then((res) => {
            if (res.code === 0) {
              this.$parent.refresh();
              this.$message({
                type: "success",
                message: `${message}成功`,
              });
              this.handleClose()
            }
          });
        })
        .catch(() => {});
    },
    // 合作、 不合作
    handleCooperation(auditStatus, { id, licenseNum }) {
      if (auditStatus === "2") {
        this.$refs.addRejectReasonRef.init("1", id, licenseNum);
        return;
      }
      if (auditStatus === '1') {
        this.$refs["formInline"].validate((valid) => {
          if (valid) {
            if (this.formInline.contractValidityStart && this.formInline.contractValidityEnd) {
              let start = new Date(this.formInline.contractValidityStart).getTime();
              let end = new Date(this.formInline.contractValidityEnd).getTime();
              if (start >= end) {
                this.$message({
                  message: "生效日期请小于截止日期",
                  type: "warning",
                });
                return;
              }
            }
            this.updateCooperationApply(auditStatus, { id, licenseNum })
          }
        })
      } else {
        this.updateCooperationApply(auditStatus, { id, licenseNum })
      }
    },
    // 审核通过、审核驳回
    handleAudit(auditStatus, { id, licenseNum }) {
      if (auditStatus === "2") {
        this.$refs.addRejectReasonRef.init("2", id, licenseNum);
        return;
      }
      let message = auditStatus === "1" ? "审核通过" : "审核驳回";
      this.$confirm(`确认要${message}吗?`, "提示", {
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          auditCooperationApply({ auditStatus, id }).then((res) => {
            if (res.code === 0) {
              this.$parent.refresh();
              this.$message({
                type: "success",
                message: `${message}成功`,
              });
              this.handleClose()
            }
          });
        })
        .catch(() => {});
    },
    // 刷新
    refresh() {
      this.$parent.refresh();
      this.handleClose()
    },
    // 初始化
    init(status, payload) {
      this.status = status;
      this.formInline = this.$options.data().formInline;
      this.operationBool = false;
      if (["distribution_audit", "distribution_details"].includes(status)) {
        this.operationBool = true;
      }

      if (status === "agency_add") {
        this.dialogTitle = "新增教务服务方";
      } else if (status === "agency_alter") {
        this.dialogTitle = "编辑教务服务方";
      } else if (status === "distribution_add") {
        this.dialogTitle = "新增招生服务方";
      } else if (status === "distribution_alter") {
        this.dialogTitle = "编辑招生服务方";
      } else if (status === "distribution_audit") {
        this.dialogTitle = "招生服务方审核";
      } else if (status === "distribution_details") {
        this.dialogTitle = "合作申请详情";
      }

      if (!["agency_add", "distribution_add"].includes(status)) {
        this.getCompanyInfo(status, payload.id);
      }
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formInline.clearValidate();
      });
    },
    async getCompanyInfo(status, id) {
      let res = [
        "distribution_audit",
        "distribution_details",
        "distribution_alter",
      ].includes(status)
        ? await getCooperationApply({ id })
        : await getCompanyInfo({ id });

      let cooperateDesire = res.data?.cooperateDesire || "";
      this.formInline = {
        id: res.data?.id || "",
        contactsName: res.data?.contactsName || "",
        contactsPhone: res.data?.contactsPhone || "",
        name: res.data?.name || "",
        contactsPosition: res.data?.contactsPosition || "",
        unitWebsite: res.data?.unitWebsite || "",
        legalRepresentative: res.data?.legalRepresentative || "",
        setUpTime: res.data?.setUpTime || "",
        staffSum: res.data?.staffSum || "",
        licenseNum: res.data?.licenseNum || "",
        registeredCapital: res.data?.registeredCapital || "",
        paidInCapital: res.data?.paidInCapital || "",
        filingSituation: res.data?.filingSituation || 1,
        evaluableOccupation: res.data?.evaluableOccupation || "",
        otherDesire: res.data?.otherDesire || "",
        licenseUrl: res.data?.licenseUrl || "",
        legalRepresentativeIdFront: res.data?.legalRepresentativeIdFront || "",
        legalRepresentativeIdReverse:
          res.data?.legalRepresentativeIdReverse || "",
        trainingBusinessExperience: res.data?.trainingBusinessExperience || "",
        trainingMode: res.data?.trainingMode || "",
        trainingTopics: res.data?.trainingTopics || "",
        trainingPersonTimes: res.data?.trainingPersonTimes || "",
        siteArea: res.data?.siteArea || "",
        operationPlace: res.data?.operationPlace || "",
        studentsChannel: res.data?.studentsChannel || "",
        trainingExperienceIntroduce:
          res.data?.trainingExperienceIntroduce || "",
        studentsIntroduce: res.data?.studentsIntroduce || "",
        otherBusiness: res.data?.otherBusiness || "",
        cooperateDesire: cooperateDesire.split(","),
        remarks: res.data?.remarks || "",
        logo: res.data?.logo || "",
        marginPic: res.data?.marginPic || "",
        contractName: res.data?.contractName || "",
        contractValidityStart: res.data?.contractValidityStart || "",
        contractValidityEnd: res.data?.contractValidityEnd || "",
        contractUrl: res.data?.contractUrl || "",
      };
      if (this.formInline.filingSituation !== 2) {
        this.formInline.evaluableOccupation = "";
      }
      if (!this.formInline.cooperateDesire.includes("3")) {
        this.formInline.otherDesire = "";
      }
      this.auditState = res.data?.auditState || "";
      this.proxyAuditState = res.data?.proxyAuditState || "";
    },
    filingSituationChange(value) {
      this.$set(this.rules, "evaluableOccupation", [
        {
          required: value === 2,
          message: "必填项不可为空",
          trigger: "blur",
        },
      ]);
      if (value !== 2) {
        this.formInline.evaluableOccupation = "";
        this.$nextTick(() => {
          this.$refs.formInline.clearValidate("evaluableOccupation");
        });
      }
    },
    cooperateDesireChange(value) {
      this.$set(this.rules, "otherDesire", [
        {
          required: value.includes("3"),
          message: "必填项不可为空",
          trigger: "blur",
        },
      ]);
      if (!value.includes("3")) {
        this.formInline.otherDesire = "";
        this.$nextTick(() => {
          this.$refs.formInline.clearValidate("otherDesire");
        });
      }
    },
    // 确认
    handleAffirm() {
      console.log(this.status, 1)
      this.$refs["formInline"].validate((valid) => {
        if (valid) {
          let params = clone(this.formInline);
          params.cooperateDesire = params.cooperateDesire.join(",");
          if (["agency_add", "agency_alter"].includes(this.status)) {
            params.targetCompanyId = "1";
          }

          if (params.contractValidityStart && params.contractValidityEnd) {
            let start = new Date(params.contractValidityStart).getTime();
            let end = new Date(params.contractValidityEnd).getTime();
            if (start >= end) {
              this.$message({
                message: "生效日期请小于截止日期",
                type: "warning",
              });
              return;
            }
          }

          if (["agency_add", "distribution_add"].includes(this.status)) {

            params.setUpTime = params.setUpTime + " 00:00:00";
            params.contractValidityStart =
              params.contractValidityStart + " 00:00:00";
            params.contractValidityEnd =
              params.contractValidityEnd + " 23:59:59";
            addCooperationApply({ ...params }).then((res) => {
              if (res.code === 0) {
                this.$parent.refresh();
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.handleClose()
              }
            });
          } else if (this.status === "agency_alter") {
            // delete params.marginPic;
            // delete params.contractName;
            // delete params.contractValidityStart;
            // delete params.contractValidityEnd;
            // delete params.contractUrl;
            updateCompanyInfo({ ...params }).then((res) => {
              if (res.code === 0) {
                this.$parent.refresh();
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.handleClose()
              }
            });
          } else if (this.status === "distribution_alter") {
            // delete params.marginPic;
            // delete params.contractName;
            // delete params.contractValidityStart;
            // delete params.contractValidityEnd;
            // delete params.contractUrl;
            if(this.proxyAuditState !== ""){
              params.proxyAuditState = this.proxyAuditState;
            }
            updateCooperationApply({ ...params }).then((res) => {
              if (res.code === 0) {
                this.$parent.refresh();
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.handleClose()
              }
            });
          }
        }
      });
    },
    // 取消
    handleClose() {
      this.file_list = []
      this.dialogVisible = false;
    },
    beforeUpload(file) {
      return oss(file.name, this.type, this.path).then((res) => {
        this.uploadHost = res.host;
        this.uploadData = res;
        this.fileData.fileName = res.key;
        this.fileData.oFileName = file.name;
        this.fileData.fileUrl = res.key;
      });
    },
    // 上传成功的回调函数
    handleSuccess(res, file, fileList) {
      this.uploadRes = res;
      if (this.type === 0) {
        // 获取公有链接
        getpublicImgUrl(this.fileData.fileName).then((res) => {
          if (res.code === 0) {
            this.fileData.fileUrl = res.data;
            this.formInline.contractUrl = res.data;
            this.fileData.name = this.fileData.fileName;
            this.fileData.url = res.data;
          } else {
            this.$message.success("获取图片链接失败");
          }
        });
      }
    },
    clearFiles() {
      this.fileData = {
        fileName: "",
        fileUrl: "",
        uploadRes: null,
      };
      this.file_list = [];
    },
    handleRemove() {
      this.formInline.contractUrl = "";
    },
    handleFormatError(file) {
      this.$message({
        message: "图片格式错误",
        type: "warning",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.handleAgency {
  ::v-deep .el-dialog__body {
    padding: 0 20px;
  }
  .form_box {
    padding-right: 40px;
  }
  .title {
    font-size: 20px;
    font-weight: bold;
    padding: 16px 0 20px 26px;
  }
  .apply-img {
    width: 360px;
    height: 180px;
    display: block;
  }
  .blue_Box {
    margin: 0 6px;
    color: #2d8cf0;
    cursor: pointer;
  }

  .blue_Box:hover {
    color: #57a3f4;
  }
}
</style>
